import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Info plăți',
    payouts: 'Plăți',
  },
  form: {
    invoicing_emails: {
      label: 'Trimiteți facturi la',
      placeholder: 'Introduceți e-mailul',
    },
    payout_schedule: {
      label: 'Program de plăți',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Plăți suspendate',
        [PAYOUT_INTERVAL.DAILY]: 'Plăți zilnice',
        [PAYOUT_INTERVAL.WEEKLY]: 'Plăți săptămânale',
        [PAYOUT_INTERVAL.MONTHLY]: 'Plăți lunare',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    amount: 'Sumă',
    cash_amount: 'Sumă numerar',
    paypal_standalone_amount: 'Sumă PayPal',
    period: 'Perioadă',
    paid_at: 'Plătit la',
    provider: 'Furnizor',
    status: 'Stare',
    actions: 'Acțiuni',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Numerar',
    system: 'Sistem',
  },
  buttons: {
    save: 'Salvează',
    actions: 'Acțiuni',
    open_report: 'Deschide raport',
    open_tracking_url: 'Urmărește plata',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'În așteptare',
    [PAYOUT_STATUSES.processing]: 'În procesare',
    [PAYOUT_STATUSES.paid]: 'Plătit',
    [PAYOUT_STATUSES.failed]: 'Eșuat',
    undefined: 'Necunoscut',
    null: 'Necunoscut',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    successfully_updated: 'Actualizat cu succes',
  },
};
